import buildSelectOptions from './build-select-options';

const buildTitleOptions = t => {
  const titles = t('TITLE_OPTIONS');
  const options = titles.split(',').map(name => ({ name: name.trim() }));
  return buildSelectOptions(options, t);
};

export default buildTitleOptions;
